<template>
  <div class="content-box">

    <div class="sub-catalog">
        <el-breadcrumb separator-class="el-icon-arrow-right">
                <el-breadcrumb-item :to="{ path: '/' }">首頁</el-breadcrumb-item>
                <el-breadcrumb-item>海關研學</el-breadcrumb-item>
                <el-breadcrumb-item>對比研究</el-breadcrumb-item>
        </el-breadcrumb>
      </div>
      <div class="sub-line"></div>



      <div class="content">

        <div class="compare-table-container">

              <div  class="compare-t-box">
                  <table  border="1" cellspacing="0" cellpadding="0" class="compare-title">
                      <tr><td class="com-t-left">對比項</td></tr>
                      <tr><td class="com-c-left-2">內容標題</td></tr>
                      <tr><td class="com-c-left1">出版物所屬系列</td></tr>
                      <tr><td class="com-c-left">出版物主要語言</td></tr>
                      <tr><td class="com-c-left1-2">出版物分類</td></tr>
                      <tr><td class="com-c-left1-2">具體數據類型</td></tr>
                      <tr><td class="com-c-left1">出版物出版者</td></tr>
                      <tr><td class="com-c-left">內容描述的具體港口名</td></tr>
                      <tr><td class="com-c-left1">出版物出版地</td></tr>
                      <tr><td class="com-c-left">冊號</td></tr>
                      <tr><td class="com-c-left1-2">篇名（中文）</td></tr>
                      <tr><td class="com-c-left-2">篇名（英文）</td></tr>
                      <tr><td class="com-c-left1">地名</td></tr>
                      <tr><td class="com-c-left">相關人物</td></tr>
                      <tr><td class="com-c-left1-2">頁碼</td></tr>
                      <tr><td class="com-content-left">內容</td></tr>
                  </table>
              </div>

              <div v-for="(tableitem, index) in tableData" :key="tableitem.value" v-on:click="clickTab(index)" class="compare-t-box">
                  <table  border="1" cellspacing="0" cellpadding="0" class="compare-content">
                      <tr><td class="com-c-db"><router-link :to="{path:'/hghome_datadetail',query:{bid:tableitem.ID}}"> 查看该条目</router-link></td></tr>
                      <tr><td class="com-c-content-2" :title=tableitem.gxsd_content_title>{{tableitem.gxsd_content_title.slice(0,40)}}</td></tr>
                      <tr><td class="com-c-content1" :title=tableitem.gxsd_pubulish_serial>{{tableitem.gxsd_pubulish_serial.slice(0,40)}}</td></tr>
                      <tr><td class="com-c-content" :title=tableitem.gxsd_main_language>{{tableitem.gxsd_main_language.slice(0,20)}}</td></tr>
                      <tr><td class="com-c-content1-2" :title=tableitem.gxsd_publish_class>{{tableitem.gxsd_publish_class.slice(0,40)}}</td></tr>
                      <tr><td class="com-c-content1-2" :title=tableitem.gxsd_data_class>{{tableitem.gxsd_data_class.slice(0,40)}}</td></tr>
                      <tr><td class="com-c-content1" :title=tableitem.gxsd_publisher>{{tableitem.gxsd_publisher.slice(0,20)}}</td></tr>
                      <tr><td class="com-c-content" :title=tableitem.gxsd_port_name>{{tableitem.gxsd_port_name.slice(0,20)}}</td></tr>
                      <tr><td class="com-c-content1" :title=tableitem.gxsd_publish_addr>{{tableitem.gxsd_publish_addr.slice(0,20)}}</td></tr>
                      <tr><td class="com-c-content" :title=tableitem.gxsd_book_number>{{tableitem.gxsd_book_number.slice(0,20)}}</td></tr>
                      <tr><td class="com-c-content1-2" :title=tableitem.gxsd_chinese_title>{{tableitem.gxsd_chinese_title.slice(0,40)}}</td></tr>
                      <tr><td class="com-c-content-2" :title=tableitem.gxsd_english_title>{{tableitem.gxsd_english_title.slice(0,100)}}</td></tr>
                      <tr><td class="com-c-content1" :title=tableitem.gxsd_addr>{{tableitem.gxsd_addr.slice(0,20)}}</td></tr>
                      <tr><td class="com-c-content" :title=tableitem.gxsd_people>{{tableitem.gxsd_people.slice(0,20)}}</td></tr>
                      <tr><td class="com-c-content1-2" :title=tableitem.gxsd_book_page>{{tableitem.gxsd_book_page.slice(0,40)}}</td></tr>
                      <tr><td class="com-content-right" :title=tableitem.gxsd_content>{{tableitem.gxsd_content.slice(0,100)}}</td></tr>
                  </table>
                  
              </div>

        </div>

      </div>
  </div>
</template>


<script>
export default {
  name: "app",
  data() {
    return {
      tableData:[],
      totaldata:'99999',
    };
  },
  methods: {

    
    getTime(date) {
      // let date = new Date()
      // return dateFormat("YYYY-mm", date)
      return date;
    },
    
    
  },
  created() {
    //获取当前条目ID号
    let ids = this.$route.query.ids;
    this.$http
      .get(`${this.$store.state.baseurl}/api/hgresearch_compare/getcomparedetail?ids=`+ids)
      .then((res) => {
        let json=JSON.parse(res.data);
        this.tableData=json.data;
        //this.tableData2=json.data2;
        //console.log(this.tableData);
      });
  },
};
</script>


<style scoped lang="scss">
.content-box {
  display: flex;
  flex-direction: column;
  min-height:600px;
  width: 100%;
  background-color: #e5e2db;
  border-width: 0px 0px 1px 0px ;
	border-style: solid;
	border-color:#cec0b2;
}
.content {
  width: 1220px;
  margin-left: auto;
  margin-right: auto;
  display: flex;
  flex-direction: row;
  justify-content: start;
  flex-wrap: wrap;
}

.compare-table-container{
    margin: 30px 30px;
    display: flex;
    flex-direction: row;
    justify-content: start;
    flex-wrap: wrap;
    .compare-t-box{
        .compare-title{
            border-collapse: collapse;
            .com-t-left{
            background-color: #999999;
            width: 200px;
            height: 50px; 
            border: 1px solid #666666;
            }
            .com-content-left{
                width: 200px;
                height: 500px;
                border: 1px solid #666666;
            }
            .com-c-left{
            border: 1px solid #666666;
            width: 200px;
            height: 35px;
            
            }
            .com-c-left-2{
            border: 1px solid #666666;
            width: 200px;
            height: 80px;
            
            }
            .com-c-left1{
            border: 1px solid #666666;
            background-color: #eeeeee;
            width: 200px;
            height: 35px;
            
            }
            .com-c-left1-2{
            border: 1px solid #666666;
            background-color: #eeeeee;
            width: 200px;
            height: 80px;
            
            }

        }
        .compare-content{
            border-collapse: collapse;
            margin-left: 3px;
            .com-content-right{
                width: 450px;
                height: 500px;
                border: 1px solid #666666;
            }
            .com-c-content{
            border: 1px solid #666666;
            width: 450px;
            height: 35px;
            overflow: hidden;
            
            }
            .com-c-content-2{
            border: 1px solid #666666;
            width: 450px;
            height: 80px;
            overflow: hidden;
            
            }
            .com-c-content1{
            border: 1px solid #666666;
            width: 450px;
            height: 35px;
            background-color: #eeeeee;
            overflow: hidden;
            }
            .com-c-content1-2{
            border: 1px solid #666666;
            width: 450px;
            height: 80px;
            background-color: #eeeeee;
            overflow: hidden;
            }
            .com-c-db{
            background-color: #999999;
            border: 1px solid #666666;
            width: 450px;
            height: 50px;
            
            }

        }
        
    }
    
}


.sub-catalog{
  width: 1220px;
  margin-left: auto;
  margin-right: auto;
  text-align: left;
  font-size: 14px;
  color: #666666;
  padding-top: 14px;
  padding-bottom: 14px;
  
}
.sub-line{
  border-width: 0px 0px 1px 0px ;
	border-style: solid;
	border-color:#cec0b2;
}






</style>